module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Mail-heart-dac708baa053fa46caa5bc2825acfce3.svg";